<template>
  <div class="app-container">
    <el-dialog title="直播准备" :visible.sync="secretBox" width="500px" center>
      <div class="dialog">
        <h4>请在obs软件中配置</h4>
        <p>开始直播：点击开始推流，结束直播：点击结束推流</p>
        <div>
          <span>服务器：</span>
          <span>{{ url_list.pre }}</span>
          <span @click="copyUrl(url_list.pre)">复制</span>
        </div>
        <div>
          <span>推流密钥：</span>
          <span>{{ url_list.nexts }}</span>
          <span @click="copyUrl(url_list.nexts)">复制</span>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="secretBox = false">确 定</el-button>
      </span>
    </el-dialog>
    <div class="top">
      <div style="justify-content: flex-start">
        <el-button v-if="query.ismanage" type="danger" style="margin-right: 20px" @click="endLive">{{
          query.play_status == 2 ? "结束直播" : query.play_status == 4 ? "恢复直播间" : "禁用直播间"
        }}</el-button>
        <el-button
          v-if="query.play_status == 2 && query.isLiver"
          type="danger"
          style="margin-right: 20px"
          @click="endLive"
          >结束直播</el-button
        >
        <span v-if="isLiver" @click="openSecretBox">查看密钥</span>
        <el-tag v-if="query.play_status == 2" size="mini">直播中</el-tag>
        <el-tag v-if="query.play_status == 1" size="mini" type="info">未开始</el-tag>
        <el-tag v-if="query.play_status == 3" size="mini" type="danger"> 已结束</el-tag>
        <el-tag v-if="query.play_status == 4" size="mini" type="danger"> 禁用中</el-tag>
      </div>
      <div class="title">
        {{ query.title }}
        <!-- <i class="el-icon-s-grid"></i> -->
      </div>
      <div>
        <div>弹幕<el-switch v-model="showDanmu" active-color="#13ce66" inactive-color="#ff4949"> </el-switch></div>
        <div>
          <i class="el-icon-time">{{ continued }}</i>
        </div>
        <div>
          <i class="el-icon-user">{{ query.user_number }}</i>
        </div>
        <div><i class="el-icon-s-data" style="color: green"></i>流畅</div>
      </div>
    </div>
    <div class="body">
      <div class="center">
        <videoPlay
          v-if="url_list.pull_flow_m3u8"
          :url="url_list.pull_flow_m3u8"
          :danmu="commentList"
          :show-danmu="showDanmu"
        ></videoPlay>
      </div>
      <div class="right">
        <div class="shang">
          <ul class="comment-box">
            <li
              v-for="item in commentList"
              :class="[item.teacher_uuid == uuid || item.user_uuid == uuid ? 'isme' : '']"
            >
              <div class="time">
                <span>{{ item.create_time }}</span>
              </div>

              <div class="msg">
                <div class="avatar">
                  <img :src="item.user.avatar" />
                </div>
                <div class="name">
                  {{ item.user.real_name }}
                </div>
              </div>
              <div class="text">
                {{ item.detail }}<el-link type="primary" class="copy-text" @click="copyText(item.detail)">引用</el-link>
              </div>
            </li>
          </ul>
        </div>
        <div class="xia">
          <textarea v-model="commentVal" rows="" cols="" placeholder="在此输入对话内容"></textarea>
          <el-button class="send" @click="sendComment">发送</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videoPlay from "./video.vue";
import Utils from "@/jslibs/utils";
import { startLive, getDanmu, sendDanmu, roomData } from "@/api/live.js";
export default {
  components: {
    videoPlay,
  },
  data() {
    return {
      uuid: Utils.getCookie("X-Access-uuid"),
      isLiver: "",
      timer: null,
      secretBox: false,
      url_list: {},
      query: this.$route.query,
      commentVal: "",
      showDanmu: false,
      continued: "00:00",
      data1: new Date().getTime(),
      timer1: null,
      timer2: null,
      commentList: [],
    };
  },
  mounted() {
    if (this.query.isLiver) {
      this.isLiver = true;
      this.showPushUrl();
    }
    if (this.query.ismanage) {
      console.log(this.query);
      this.url_list = this.query;
    }
    const t1 = localStorage.getItem("liveTime");
    const t2 = new Date().getTime();

    if (t2 - t1 < 1000 * 60 * 60 * 6) {
      this.data1 = t1;
    } else {
      localStorage.setItem("liveTime", t2);
    }

    this.setTime();
    this.getDanmuList();
    this.getRoomData();
    this.getRoomInfo();
  },
  beforeDestroy() {
    localStorage.removeItem("liveTime");
    clearTimeout(this.timer1); // 实时更新人数，开始时间
    clearTimeout(this.timer2); // 实时更新人数，
    clearTimeout(this.timer); // 实时更新弹幕
  },
  methods: {
    async getRoomInfo() {
      const res = await roomData(this.query.info_uuid || this.query.uuid, { interval: this.interval });
      if (res) {
        this.query = { ...this.query, ...res };
      }
      clearTimeout(this.timer2);
      this.timer2 = setTimeout(() => {
        this.getRoomInfo();
      }, 10000);
    },
    async getRoomData() {
      const res = await roomData(this.query.info_uuid || this.query.uuid, { interval: this.interval });
      if (res) {
        this.query = { ...this.query, ...res };
        if (this.isLiver) {
          this.url_list = { ...this.url_list, ...res };
        }
      }
    },
    setTime() {
      // const time1 = new Date(this.query.start_time)
      const time1 = this.data1;
      const time2 = new Date();

      const secs = parseInt(time2.getTime() / 1000 - time1 / 1000);
      this.continued = Math.floor(secs / 60) + ":" + (secs % 60);
      this.timer1 = setTimeout(() => {
        this.setTime();
      }, 1000);
    },
    async getDanmuList() {
      const res = await getDanmu({
        live_uuid: this.query.info_uuid || this.query.uuid,
      });
      if (res.data instanceof Array) {
        this.commentList = res.data;
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.getDanmuList();
      }, 5000);
    },
    async endLive() {
      const stu = this.query.play_status;
      const tag = ["", "禁用", "关闭", "禁用", "解禁"][stu];
      this.$confirm("确定要" + tag + "该直播吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let tyupe = "end";
          if (stu == 2) {
          } else if (stu == 4) {
            tyupe = "resume";
          } else {
            tyupe = "disable";
          }
          startLive(this.query.live_uuid, { type: tyupe }).then((res) => {
            if (res === true) {
              this.getRoomData();
              this.$message.success("成功");
              if (tyupe == "end") {
                this.$router.go(-1);
              }
            }
          });
        })
        .catch(() => {});
    },
    copyUrl(text) {
      console.log(text);
      var input = document.createElement("input");
      document.body.appendChild(input);
      input.value = text; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      // input.remove()

      document.body.removeChild(input);
      this.$message.success("复制成功");
    },
    async showPushUrl() {
      // const res = await startLive(this.query.uuid, { type: 'start' })
      // if (!res) {
      //     return
      // }
      const res = this.query;
      const push_flow = res.push_flow;
      const pre = push_flow.substring(0, push_flow.lastIndexOf("/"));
      const nexts = push_flow.substring(push_flow.lastIndexOf("/") + 1);
      this.url_list = { ...this.url_list, ...res, pre, nexts };
      this.openSecretBox();
    },
    openSecretBox() {
      this.secretBox = true;
    },
    sendComment() {
      if (!this.commentVal) {
        this.$message.warning("请输入您的弹幕");
      } else {
        const uuids = { teacher_uuid: this.uuid };
        // if (Utils.getCookie('X-Access-Group')!=927) {
        //     uuids = {
        //         admin_uuid: this.uuid
        //     }
        // } else {
        //     uuids = {
        //         teacher_uuid: this.uuid
        //     }
        // }

        sendDanmu({
          detail: this.commentVal,
          live_uuid: this.query.uuid,
          ...uuids,
          // teacher_uuid: this.query.teacher_uuid
        }).then((res) => {
          console.log(res);
          if (res === true) {
            this.getDanmuList();
            this.$message.success("发送成功");
            this.commentVal = "";
          }
        });
        // this.commentList.push({
        //     name: '游客', id: 124, userCode: 8, avatar: '', content: this.commentVal, time: new Date().format('yyyy-MM-dd hh:mm:ss')
        // })
      }
    },
    copyText(text) {
      this.commentVal = text;
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.dialog {
  h4 {
    text-align: center;
  }
  div {
    display: flex;
    line-height: 2;
    margin: 10px 0;
    border: 1px solid #bbb;
    white-space: nowrap;
    span:nth-child(1) {
      width: 18%;
      background-color: #333;
      color: #fff;
      padding: 0 5px;
      box-sizing: border-box;
    }
    span:nth-child(2) {
      width: 72%;
      overflow-x: auto;
      padding: 0 5px;
      box-sizing: border-box;
      &::-webkit-scrollbar {
        /*滚动条整体样式*/

        display: none;
      }

      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/

        border-radius: 10px;

        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

        background: #535353;
      }

      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/

        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);

        border-radius: 10px;

        background: #ededed;
      }
    }
    span:nth-child(3) {
      width: 10%;
      cursor: pointer;
      background-color: deepskyblue;
      color: white;
      text-align: center;
    }
  }
}
.app-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .top {
    height: 10%;
    background-color: #333;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > div {
      display: flex;
      align-items: center;
      margin: 0 12px;
      width: 25%;
      justify-content: space-between;

      &.title {
        justify-content: center;
      }
    }
  }

  .body {
    height: 90%;
    display: flex;
    background-color: #666;

    .left {
      width: 10%;
      background-color: #444;
    }

    .center {
      width: 75%;
      background-color: #444;
    }

    .right {
      width: 25%;
      background-color: #777;
      display: flex;
      flex-direction: column;
      .shang {
        height: 70%;
        overflow: hidden;
        background: #666;
      }
    }

    .xia {
      height: 30%;
      border-top: 5px solid #999;
      position: relative;
      textarea {
        background: #99999999;
        width: 100%;
        height: 100%;
        outline: none;
        color: white;
      }
      .send {
        position: absolute;
        right: 10px;
        bottom: 10px;
      }
    }
  }
}

.comment-box {
  padding: 10px;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  .isme {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .msg {
      display: flex;
      flex-direction: row-reverse;
    }
    .text {
      .copy-text {
        position: absolute;
        white-space: nowrap;
        right: 102%;
        left: auto;
      }
    }
    .time {
      width: 100%;
    }
  }
  li {
    list-style: none;
  }
  .msg {
    display: flex;
    align-items: center;
    color: #fff;
    font-weight: 600;
  }
  .avatar {
    width: 30px;
    margin: 0 10px;
    height: 30px;
    background-color: #999;
    border-radius: 100px;
  }
  .text {
    background-color: #999;
    margin: 10px;
    padding: 10px 15px;
    border-radius: 10px;
    display: inline-block;
    position: relative;
    .copy-text {
      position: absolute;
      white-space: nowrap;
      left: 102%;
    }
  }
  .time {
    text-align: center;
    span {
      color: white;
      background-color: #aaa;
      font-size: 12px;
      border-radius: 100px;
      padding: 4px;
    }
  }
}
</style>
